import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

const defaultFilter = {
  permissionCategory: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function Permissions(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);
  const [selectedItemCheckedOptions, setSelectedItemCheckedOptions] = useState([]);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getPermissions')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = e => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    setSelectedItemCheckedOptions([]);

    if (selectedItem === null || selectedItemOperation === null)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editPermission':
        warning = warning === null ? selectedItem.permissionCategory.length < 6 ? 'Numele categoriei de permisiuni este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.permission.length < 6 ? 'Numele permisiunii este prea scurt' : null : warning;
        break;

      case 'userPermissions':
        setSelectedItemCheckedOptions(data.userPermissions.filter(userPermission => userPermission.idPermission === selectedItem.id && userPermission.checked === '1').map(userPermission => userPermission.idUser));
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]);

  const handleItemCheckedOptionsToggle = value => () => {
    const currentIndex = selectedItemCheckedOptions.indexOf(value);
    const newChecked = [...selectedItemCheckedOptions];

    if (currentIndex === -1)
      newChecked.push(value);
    else
      newChecked.splice(currentIndex, 1);

    setSelectedItemCheckedOptions(newChecked);
  };

  const filterData = item => true
      && (filter.permissionCategory === '0' || item.permissionCategory === filter.permissionCategory)
      && (
           !!~item.permission.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.description.toLowerCase().indexOf(filter.text.toLowerCase())
      )
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleEditPermission = () => {
    setIsLoaded(false);
    ajax('savePermission', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleSavePermissionUsers = () => {
    setIsLoaded(false);
    ajax('savePermissionUsers', {
      idPermission: selectedItem.id,
      idUsers: selectedItemCheckedOptions
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeletePermission = () => {
    setIsLoaded(false);
    ajax('markPermissionAsDeleted', {
      idPermission: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeletePermission = () => {
    setIsLoaded(false);
    ajax('markPermissionAsUndeleted', {
      idPermission: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Permisiuni aplicatie</Typography>
      <Typography variant='subtitle2'>Administrare permisiuni aplicatie.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.permissions.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.permissions.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select
              label='Categorie permisiuni'
              placeholder='Categorie permisiuni'
              name='permissionCategory'
              value={filter.permissionCategory}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toate categoriile</MenuItem>
              {data.permissionCategories.map(option => (
                <MenuItem key={option.permissionCategory} value={option.permissionCategory}>
                  {option.permissionCategory}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza permisiunile sterse'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.permissions.length > 0 && data.permissions.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.permissions.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].permissionCategory !== a[i - 1].permissionCategory) &&
                <ListSubheader color='primary' disableSticky>{item.permissionCategory}</ListSubheader>
              }

              <ListItem dense button className={classes.listItemDense}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editPermission');
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography style={{fontWeight: 'bold'}}>{item.permission}</Typography>
                  }
                  secondary={
                    <Box>
                      {filter.showExtendedInfo &&
                        <Typography color='textSecondary'>
                          {`Creat de `}
                          <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                          {` la data de `}
                          <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                        </Typography>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editPermission')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('userPermissions')}>
          <ListItemIcon className={classes.listItemIcon}><ListIcon fontSize='small' color='action' /></ListItemIcon>
          <Typography variant='body1'>Utilizatori asociati</Typography>
        </MenuItem>

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deletePermission')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeletePermission')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem({
              id: '',
              permissionCategory: '',
              permission: '',
              description: ''
            });
            setSelectedItemOperation('editPermission');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga permisiune
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editPermission' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editPermission'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.permission ? selectedItem.permission : 'Adaugare permisiune noua'}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete freeSolo
                    renderInput={(params) => (
                      <TextField {...params} required margin='none'
                        label='Categorie permisiune'
                        placeholder='Categorie permisiune'
                      />
                    )}
                    options={data.permissionCategories.map(option => option.permissionCategory)}
                    value={selectedItem.permissionCategory}
                    onChange={(e, newValue) => handleSelectedItemChange({...e, target: {...e.target, name: 'permissionCategory', value: newValue}})}
                    inputValue={selectedItem.permissionCategory}
                    onInputChange={(e, newValue) => handleSelectedItemChange({...e, target: {...e.target, name: 'permissionCategory', value: newValue}})}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume permisiune'
                    placeholder='Nume permisiune'
                    name='permission'
                    value={selectedItem.permission}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={selectedItem.description}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditPermission}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'userPermissions' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'userPermissions'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Utilizatori asociati - {selectedItem.permission}</DialogTitle>
          <DialogContent>
            <List dense>
              {data.users.map((item, i, a) =>
                <Fragment key={item.id}>
                  {(i === 0 || a[i].partner !== a[i - 1].partner) &&
                    <ListSubheader color='primary' disableSticky>{item.partner}</ListSubheader>
                  }

                  <ListItem dense button className={classes.listItemDense}
                    onClick={handleItemCheckedOptionsToggle(item.id)}
                  >
                    <ListItemIcon>
                      <Checkbox size='small' disableRipple edge='start' tabIndex={-1} color='primary'
                        checked={selectedItemCheckedOptions.indexOf(item.id) !== -1}
                      />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemTextDense}
                      primary={item.name}
                      secondary={
                        <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                      }
                    />
                  </ListItem>
                </Fragment>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            <FormControlLabel style={{marginLeft: '32px', marginRight: 'auto'}}
              control={
                <Checkbox size='small' disableRipple edge='start' color='secondary'
                  checked={selectedItemCheckedOptions.length > 0} // using selectedItemCheckedOptions.length === data.users.length will make a grey checkbox for indeterminate value
                  indeterminate={selectedItemCheckedOptions.length > 0 && selectedItemCheckedOptions.length !== data.users.length}
                  onChange={() => {
                    setSelectedItemCheckedOptions(selectedItemCheckedOptions.length === data.users.length ? [] : data.users.map(user => user.id));
                  }}
                />
              }
              label={
                <Typography color='secondary'>{selectedItemCheckedOptions.length === data.permissions.length ? 'Deselecteaza tot' : 'Selecteaza tot'}</Typography>
              }
            />
          </DialogActions>
          <DialogActions>
            <Link to='/Users' className={classes.link} style={{marginRight: 'auto'}}>
            <Button style={{color: 'darkblue'}}>
                Utilizatori
              </Button>
            </Link>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSavePermissionUsers}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deletePermission' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deletePermission'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati aceasta permisiune ca stearsa?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti aceasta permisiune. Dupa stergere, toti utilizatorii care aveau asociati aceasta permisiune nu vor mai beneficia de ea.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeletePermission}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeletePermission' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeletePermission'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestei permisiuni ca sterse?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestei permisiuni. Dupa confirmare, toti utilizatorii care aveau asociati aceasta permisiune vor beneficia din nou de ea.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeletePermission}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}